@let requestWorkflows = $requestWorkflows();
@let returnLink = $returnLink();
@let isDesktop = deviceService.isDesktop$ | async;

<!-- Desktop layout -->
@if (isDesktop) {
  <tui-elastic-container class="desktop-width-limit min-h-[100vh]">
    <x-workflow-header
      [isWelcomeStep]="false"
      [isRootPage]="true"
      [returnLink]="returnLink"
      [baseRoute]="$baseRoute()"
    />
    <x-workflow-screen-state
      [state]="$screenState()"
      [pendingWork]="$pendingWork()"
      (retry)="retryFailedSync()"
    />
    @if (requestWorkflows.length) {
      <div
        class="x-card x-card_size_m pt-0 flex! list-items-container gap-20 justify-center"
      >
        <section class="mt-10">
          <x-workflow-stepper [baseRoute]="$baseRoute()" />
        </section>
        <section class="mt-10 w-[28rem] max-w-full">
          <ng-container
            *ngTemplateOutlet="workflowsList; context: { $implicit: true }"
          />
        </section>
      </div>
    } @else if ($isEmptyListState()) {
      <x-empty-block [title]="'workflows.screen_state.empty' | translate" />
    }
  </tui-elastic-container>
} @else {
  <!-- Mobile layout -->
  <tui-scrollbar
    style="scrollbar-width: thin"
    class="h-full"
    [ngClass]="{ 'desktop-width-limit': isDesktop }"
  >
    <x-workflow-header
      [isWelcomeStep]="false"
      [isRootPage]="true"
      [returnLink]="returnLink"
      [baseRoute]="$baseRoute()"
    />
    <x-workflow-screen-state
      [state]="$screenState()"
      [pendingWork]="$pendingWork()"
      (retry)="retryFailedSync()"
    />
    @if (requestWorkflows.length) {
      <div
        class="x-card x-card_size_m pt-0 h-[calc(100vh-80px)] flex! flex-col list-items-container"
      >
        <section class="mt-4">
          <ng-container
            *ngTemplateOutlet="workflowsList; context: { $implicit: false }"
          />
        </section>
        <section class="mt-5">
          <x-workflow-stepper [baseRoute]="$baseRoute()" />
        </section>
      </div>
    } @else if ($isEmptyListState()) {
      <x-empty-block [title]="'workflows.screen_state.empty' | translate" />
    }
  </tui-scrollbar>
}

<!-- Shared workflows list template -->
<ng-template #workflowsList let-isDesktop>
  @for (rwf of requestWorkflows; track rwf.id; let count = $count) {
    @let rwfID = rwf.id;
    <tui-accordion
      size="m"
      [closeOthers]="false"
      class="workflows-list-accordion"
    >
      <button
        type="button"
        class="main-accordion-item-button"
        [tuiAccordion]="isDesktop"
      >
        <div class="flex items-center gap-2 min-w-0">
          <p
            class="x-font-body-3-bold ps-2 min-w-0 flex-1 break-words whitespace-normal"
          >
            @if (getRequestProduct(rwf.requestProductId); as requestProduct) {
              <x-request-product-icon
                [requestDevices]="$request().devices"
                [requestProduct]="requestProduct"
                [withCounter]="false"
                [iconSize]="RequestProductIconSize.Md"
              />
            }
            <span class="wrap-break-word whitespace-normal">
              {{ getWorkflowName(rwfID) }}
            </span>
          </p>
          <div class="shrink-0">
            <button
              appearance="icon"
              tuiIconButton
              type="button"
              size="s"
              class="mx-1"
              iconStart="@tui.archive"
              [title]="'workflows.events_dialog.open_button' | translate"
              [attr.aria-label]="
                'workflows.events_dialog.open_button' | translate
              "
              (click)="$event.stopPropagation(); openWorkflowEventsModal(rwf)"
            ></button>
          </div>
        </div>
      </button>
      <tui-expand>
        <!-- Каждый узел — отдельная карточка: заголовок (название + «Заполнено X из Y»), внутри — формы -->
        <div class="flex flex-col gap-2">
          @for (node of rwf.nodes; track node.id) {
            @let forms = getWorkflowNodeForms(node.id) | async;
            @let someNodeFormsAreInvalid =
              someNodeFormsAreInvalid$(node.id, rwf.id) | async;
            @let allNodeFormsCompleted =
              allNodeFormsCompleted$(node.id, rwf.id) | async;

            <tui-accordion
              size="m"
              [closeOthers]="false"
              class="workflow-node-card"
            >
              <button type="button" [tuiAccordion]="false">
                <span class="flex flex-col items-start min-w-0 text-start">
                  <span
                    class="text-[17px]/[24px] x-text-dark-main font-normal break-words whitespace-normal"
                    [ngClass]="{
                      'x-text-green': allNodeFormsCompleted,
                      'x-text-red': someNodeFormsAreInvalid,
                    }"
                  >
                    {{ node.title }}
                  </span>
                  <span class="text-[15px]/[24px] x-text-dark-75 font-normal">
                    Заполнено
                    <span class="ms-2">
                      {{ getNodeValidFormsCount$(node.id, rwf.id) | async }} из
                      {{ forms?.length }}
                    </span>
                  </span>
                </span>
              </button>
              <tui-expand>
                @for (form of forms; track form.id) {
                  @let formIsInvalid = formIsInvalid$(form.id, rwf.id) | async;
                  @let formIsSubmitted =
                    formIsSubmitted$(form.id, rwf.id) | async;

                  <a
                    class="node-form-item text-[17px]/[24px] font-medium x-text-dark-main"
                    [ngClass]="{
                      'x-text-red': formIsInvalid,
                      'x-text-green': !formIsInvalid && formIsSubmitted,
                    }"
                    [routerLink]="['.', rwf.id, node.id, form.id]"
                  >
                    {{ form.title }}
                  </a>
                }
              </tui-expand>
            </tui-accordion>
          }
        </div>
      </tui-expand>
    </tui-accordion>
    @if (count > 1) {
      <hr />
    }
  }
</ng-template>
